import { customAlphabet } from "nanoid";

// Numbers and alphabet without hyphens or underscores for cleaner IDs
// Also, no collision with google cloud project id requirements
// 36 characters: 0-9 a-z
const ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";

export const nanoid = customAlphabet(ALPHABET, 16);
